import {LOAD_BRANDS_SUCCESS, CLEAR_BRANDS } from '../../actions/types';

const INITIAL_STATE = [];

export default (state=INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_BRANDS_SUCCESS:
            return action.payload;
        case CLEAR_BRANDS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/brands/BrandsReducer.js